import React from 'react'
import CardCarousel from './CardCarousel'
import { socialMediaPosts } from '../../utils/socialMediaPostsData'

const Posts = () => {
  return (
    <div id='posts' className='p-4 mt-5'>
      <div className='container'>
        <div className='postHeader'>
          <h1 className='fw-bolder'>My Recent <span className='fw-medium fst-italic text-warning'>Posts</span></h1>
        </div>

        <div className='socialWrapper'>
          {
            socialMediaPosts.map(socialMediaPost => {
              return(
                <div className='socialSection'>
                  <div className='scoialHeader mt-5 p-3'>
                    <h1 className={`fw-bolder ${socialMediaPost.socialMedia === 'Linkedin' ? 'text-primary' : ''}`}>{socialMediaPost.socialMedia}</h1>
                    <p className='fw-semibold text-secondary'>{socialMediaPost.details.cnt} {socialMediaPost.details.type}</p>
                    <a href={socialMediaPost.profileUrl} target='_blank' rel="noopener noreferrer">
                      <button className='btn btn-primary'>Follow Me</button>
                    </a>
                  </div>
                  <div className='socialPostSection'> 
                    <CardCarousel posts={socialMediaPost.posts} socialMedia={socialMediaPost.socialMedia} />   
                  </div>
                </div>
              )
            })
          }
        </div>    
      </div>
    </div>
  )
}

export default Posts